import { render, staticRenderFns } from "./settleRecordList.vue?vue&type=template&id=0657c641&scoped=true"
import script from "./settleRecordList.vue?vue&type=script&lang=js"
export * from "./settleRecordList.vue?vue&type=script&lang=js"
import style0 from "./settleRecordList.vue?vue&type=style&index=0&id=0657c641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657c641",
  null
  
)

export default component.exports